<section *ngIf="(policy$ | async) as policy">
    <span [innerHtml]="policy.data.attributes.text"></span>
</section>